module.exports = __webpack_public_path__ + "static/media/group-8.72e68853.png";